/**
 * Focus mode (owner UX) — the immersive EDITOR routes where an accidental
 * click on the app chrome (sidebar / topbar) would abandon unsaved work.
 * While one of these routes is open, `AppShell` blurs the chrome and makes
 * it `inert`: the way OUT of the editor is its own back button (the normal
 * flow), never a click on the locked bars — so a stray click costs nothing.
 *
 * List pages deliberately DON'T match (`/workflows`, `/etl`, `/etl/lanes`,
 * `/apps`, `/report-types`): they hold no unsaved canvas state, and locking
 * them would trap navigation everywhere.
 */
const FOCUS_ROUTES: RegExp[] = [
  // Workflow editor (+ the legacy /automations alias).
  /^\/(workflows|automations)\/[^/]+/,
  // ETL designer — NOT the /etl list nor /etl/lanes.
  /^\/etl\/(?!lanes(?:\/|$))[^/]+/,
  // The app builder IDE + every per-app standalone route (tables, datasets,
  // forms, builder, …) — NOT the /apps list.
  /^\/apps\/[^/]+/,
  // Report designer (the canvas), NOT the /report-types master/detail page.
  /^\/report-types\/[^/]+\/reports\/[^/]+\/designer/,
];

export function isFocusRoute(pathname: string): boolean {
  return FOCUS_ROUTES.some((re) => re.test(pathname));
}
